export * from './decoration-description.component';
